import styled from 'styled-components';

import { Button } from '@sternum/ui';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
`;

export const OptionsBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const TodayButton = styled(Button)`
  padding: 4px 10px;
  min-width: auto;
  transition: 0.2s ease;

  &[data-hidden='true'] {
    opacity: 0;
    pointer-events: none;
  }
`;
